import React from 'react'

export default props => (
    <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 18.99 15.07"
        {...props}
    >
        <path
            d="M982.13,512.67v2.12a1,1,0,0,0-.5.87,1,1,0,0,0,.28.72,1,1,0,0,0,.72.28,1,1,0,0,0,.84-.47h3.64v-1H983.5a1,1,0,0,0-.37-.4v-2.12Z"
            transform="translate(-970.62 -508.68)"
        />
        <path
            d="M987.57,510.72a7,7,0,0,0-9.88,0l-.07.07a2,2,0,0,1,1,.42,5,5,0,0,1,.81-.6l.5.84.43-.25-.5-.84a5.81,5.81,0,0,1,2.53-.68v1h.5v-1a5.73,5.73,0,0,1,2.52.68l-.5.84.44.25.5-.84a5.52,5.52,0,0,1,1.84,1.84l-.85.5.25.44.84-.5a5.62,5.62,0,0,1,.69,2.52h-1v.5h1a5.62,5.62,0,0,1-.69,2.52l-.84-.5-.25.44.85.5a5.38,5.38,0,0,1-.81,1,5.71,5.71,0,0,1-1,.81l-.5-.84-.44.25.5.84a6,6,0,0,1-1.61.58,2.58,2.58,0,0,1,.07,1,7,7,0,0,0,3.71-11.82Z"
            transform="translate(-970.62 -508.68)"
        />
        <path
            d="M977.11,515.5c-.1-.16-.2-.31-.29-.47a.54.54,0,0,0-.73-.25.52.52,0,0,0-.21.73,3.72,3.72,0,0,0,.93,1.16.21.21,0,0,1,.08.21c0,.34-.07.68-.1,1l.69.12,1,.15a.63.63,0,0,1,.51.39c.3.76.6,1.52.89,2.27a.66.66,0,0,1-1.22.48c-.24-.6-.48-1.19-.71-1.79a.17.17,0,0,0-.17-.13l-2-.31a1,1,0,0,1-.84-1,6.1,6.1,0,0,1,.3-2.78,1.49,1.49,0,0,1,.59-.8.81.81,0,0,1,1.33.67c0,.1,0,.2,0,.3Z"
            transform="translate(-970.62 -508.68)"
        />
        <path
            d="M972.26,522.53h-.9a7.2,7.2,0,0,1,.58-2.17c-.23,0-.24-.19-.23-.37s0-.25,0-.38.08-.26.26-.26h4.15c.24,0,.3.06.3.3s0,.31,0,.47a.22.22,0,0,1-.07.17.15.15,0,0,0-.06.16,4.35,4.35,0,0,0,.37,1.37.13.13,0,0,0,.15.09H980v.62h-4.17a1.82,1.82,0,0,0-.55-1.68,1.79,1.79,0,0,0-1.37-.49A1.84,1.84,0,0,0,972.26,522.53Z"
            transform="translate(-970.62 -508.68)"
        />
        <path
            d="M980.29,522.18a1.57,1.57,0,1,1,1.56,1.57A1.57,1.57,0,0,1,980.29,522.18Zm2.18,0a.62.62,0,1,0-.62.62A.61.61,0,0,0,982.47,522.18Z"
            transform="translate(-970.62 -508.68)"
        />
        <path
            d="M975.63,522.18a1.57,1.57,0,1,1-1.57-1.56A1.56,1.56,0,0,1,975.63,522.18Zm-1.56.62a.62.62,0,1,0,0-1.23.62.62,0,1,0,0,1.23Z"
            transform="translate(-970.62 -508.68)"
        />
        <path
            d="M978.6,512.5c-.15,0-.3,0-.44.08a2.09,2.09,0,0,0-.35.13.34.34,0,0,0-.18.36l.06.39a.66.66,0,0,1,0,.14c0,.19,0,.25-.22.27a1.81,1.81,0,0,1-1.1-.15,1,1,0,0,1-.47-.76,1.37,1.37,0,0,1,2.67-.6S978.59,512.45,978.6,512.5Z"
            transform="translate(-970.62 -508.68)"
        />
        <path
            d="M979.32,517.49l-.49.18a.25.25,0,0,1-.36-.21h.64a.51.51,0,0,0,.42-.17,1.58,1.58,0,0,0,.17-.29.5.5,0,0,1,0,.13c.12.32.23.65.34,1a.29.29,0,0,0,.1.12,2.46,2.46,0,0,1,1.38,1.54s0,.07.06.07a7.86,7.86,0,0,1,.84.19,1.86,1.86,0,0,1,1,.87s.06.08,0,.12a.25.25,0,0,1,0,.16c-.06.05-.1,0-.14,0a1.79,1.79,0,0,0-1.57-.77,1.76,1.76,0,0,0-1.17.48l-.1.1Z"
            transform="translate(-970.62 -508.68)"
        />
        <path
            d="M978.88,517.36a3.38,3.38,0,0,1-2.9-1.89.42.42,0,0,1,0-.47.41.41,0,0,1,.41-.17.43.43,0,0,1,.32.25,2.71,2.71,0,0,0,1.36,1.27,2.4,2.4,0,0,0,1,.16.42.42,0,0,1,.45.53.43.43,0,0,1-.35.31Z"
            transform="translate(-970.62 -508.68)"
        />
        <path
            d="M981.41,517.3c0,.21-.08.41-.14.6s-.17.23-.36.2a.8.8,0,0,1-.67-.82.82.82,0,0,1,.73-.77.23.23,0,0,1,.28.17A6.25,6.25,0,0,1,981.41,517.3Z"
            transform="translate(-970.62 -508.68)"
        />
        <path
            d="M976.53,513.94a5.78,5.78,0,0,0,.83,0c.4,0,.47-.11.44-.52,0-.13,0-.26-.06-.4a.24.24,0,0,1,.14-.28,4.94,4.94,0,0,1,.55-.15s.07,0,.08.08a1.18,1.18,0,0,1-.9,1.61A1.16,1.16,0,0,1,976.53,513.94Z"
            transform="translate(-970.62 -508.68)"
        />
        <path
            d="M974.17,515.24H971c-.23,0-.33.1-.33.33v3.17c0,.23.1.33.33.33h3.22c.23,0,.33-.1.33-.33v-3.17C974.5,515.34,974.4,515.24,974.17,515.24Zm-.44,2.7h-1.86a.19.19,0,0,1-.18-.19.18.18,0,0,1,.18-.18h1.86a.19.19,0,0,1,.19.18A.2.2,0,0,1,973.73,517.94Zm0-.75h-1.42a.18.18,0,0,1-.18-.19.18.18,0,0,1,.18-.18h1.42a.19.19,0,1,1,0,.37Zm0-.75H973a.19.19,0,1,1,0-.37h.74a.19.19,0,1,1,0,.37Z"
            transform="translate(-970.62 -508.68)"
        />
    </svg>
)
